import { z } from 'zod';
import { servicesProviderPricingFixedSchema, servicesProviderPricingFixedDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Pricing Schemas
// ============================================================================
const financingBrokeragePlatformServicePricingSchema = servicesProviderPricingFixedSchema;
const financingBrokeragePlatformServicePricingDtoSchema = servicesProviderPricingFixedDtoSchema;
// ============================================================================
// Core Schema
// ============================================================================
const financingBrokeragePlatformServiceConfigSchema = serviceConfigSchema.extend({
    pricing: z.array(financingBrokeragePlatformServicePricingSchema).optional(),
});
// ============================================================================
// DTO Schema
// ============================================================================
const financingBrokeragePlatformServiceConfigDtoSchema = serviceConfigSchema.extend({
    pricing: z.array(financingBrokeragePlatformServicePricingDtoSchema).optional(),
});

export { financingBrokeragePlatformServiceConfigDtoSchema, financingBrokeragePlatformServiceConfigSchema, financingBrokeragePlatformServicePricingDtoSchema, financingBrokeragePlatformServicePricingSchema };
//# sourceMappingURL=FinancingBrokeragePlatformServiceConfig.js.map
